export default __webpack_public_path__ + "static/media/post-it.7c831644.png";